import { ChimeSDKMessagingClient } from "@aws-sdk/client-chime-sdk-messaging";
import { ChimeSDKIdentityClient } from "@aws-sdk/client-chime-sdk-identity";
import {
  ConsoleLogger,
  DefaultMessagingSession,
  LogLevel,
  MessagingSessionConfiguration,
  PrefetchOn,
  PrefetchSortBy,
} from "amazon-chime-sdk-js";
import { fetchAuthSession } from "aws-amplify/auth";

const REGION = "us-east-1";

const chatService = async ({
  appInstanceUserArn,
}: {
  appInstanceUserArn: string;
}) => {
  const getAuthCredentials = async () => {
    const credentials = (await fetchAuthSession()).credentials;

    if (!credentials) {
      throw new Error("No auth session found");
    }

    return {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken,
      expiration: credentials.expiration,
    };
  };

  const messagingClient = new ChimeSDKMessagingClient({
    region: REGION,
    credentials: async () => await getAuthCredentials(),
  });

  const identityClient = new ChimeSDKIdentityClient({
    region: REGION,
    credentials: async () => await getAuthCredentials(),
  });

  const configuration = new MessagingSessionConfiguration(
    appInstanceUserArn,
    null,
    undefined,
    messagingClient,
  );

  configuration.prefetchOn = PrefetchOn.Connect;
  configuration.prefetchSortBy = PrefetchSortBy.LastMessageTimestamp;

  const logger = new ConsoleLogger("SDK", LogLevel.INFO);

  const session = new DefaultMessagingSession(configuration, logger);

  return {
    messagingClient,
    identityClient,
    session,
  };
};

export default chatService;
